import styled from 'styled-components'

export const Container = styled.div`
display: flex;
flex-direction: column;
padding: 1rem;
border-radius: 1rem;
border:1px solid var(--Azul);
`
